import { getCookie } from '@lhb/cache';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { ignoreErrors } from 'src/common/ignore/sentryError';

/** 初始化 sentry */
export const initSentry = () => {
  // 接入sentry，预演、线上环境接入
  if (process.env.NODE_ENV === 'production' && process.env.SENTRY_DSN) {
    // https://docs.sentry.io/platforms/javascript/configuration/options/
    Sentry.init({
      dsn: process.env.SENTRY_DSN,
      environment: process.env.NODE_ENV,
      release: 'lcn-web@' + process.env.xClientVersion,
      integrations: [
        new BrowserTracing({
          tracePropagationTargets: ['localhost', 'my-site-url.com', /^\//],
        }),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
      // 忽略无意义的错误
      ignoreErrors,
      beforeSend(event: any) {
        // console.log(`event`, event);
        // 如果 ignoreErrors 生效，不会走到这里，这里做兜底
        const eventExceptionMessage = Array.isArray(event.exception?.values) && event.exception?.values.length ? event.exception?.values?.[0]?.value : '';
        if (eventExceptionMessage && ignoreErrors.some(pattern => eventExceptionMessage.match(pattern))) {
          return null; // 返回null表示忽略该错误事件
        }
        // 排除依赖包本身的报错
        if (event.location && event.location.match(/\/node_modules\//gi)) {
          return null;
        }
        // 排除地图本身的报错
        if (event.location && event.location.match(/https:\/\/webapi\.amap\.com/gi)) {
          return null;
        }
        // 排除静态资源包的报错
        if (event.location && event.location.match(/https:\/\/staticres\.linhuiba\.com\/libs/gi)) {
          return null;
        }

        // console.log(`hint`, hint);
        const kunlunUserId = getCookie('kunlun_user_id');
        const kunlunTK = getCookie('kunlun_token');
        if (event && event.extra) {
          event.extra.userInfo = {
            kunlunUserId,
            // 上报的是token，这里不用token是因为sentry把token当成了关键词，会把一切包含于token的转换为不可见的字符
            kunlunTK,
            des: '为方便前端快速排查问题，额外上报的信息',
          };
        }
        return event;
        // return null 会将此次上报丢弃
      }
    });
  }
};
